import React, { useEffect } from 'react';

import RoundedInput from '../../../components/Inputs/RoundedInput';

import classes from './styles.module.scss';

export default function FileDescriptions({
  selectedFileId,
  files,
  prevFiles,
  descriptions,
  setDescriptions,
}) {
  useEffect(() => {
    setDescriptions((prev) => {
      const updated = [...prev];

      files.forEach((file) => {
        if (!prev.find((prevFile) => prevFile.size === file.size)) {
          updated.push({
            name: file.name,
            description: '',
            size: file.size,
          });
        }
      });

      prevFiles.forEach((file) => {
        const index = prev.findIndex((prevFile) => prevFile.id === file.id);
        if (index === -1) {
          updated.push({
            name: file.name,
            description: file.description || '',
            id: file.id,
          });
        } else {
          updated[index] = {
            ...updated[index],
            name: file.name,
            description: file.description || '',
          };
        }
      });

      return updated;
    });
  }, [files, prevFiles, setDescriptions]);

  const current = descriptions?.find?.(
    (desc) => desc.id === selectedFileId || desc.size === selectedFileId
  ) || {
    name: '',
    description: '',
  };

  return (
    <div className={classes.FileDescriptions}>
      <RoundedInput
        label="Name"
        value={current.name}
        onChange={(event) =>
          setDescriptions((prev) => {
            const updated = [...prev];
            const index = updated.findIndex(
              (desc) =>
                desc.id === selectedFileId || desc.size === selectedFileId
            );
            if (index !== -1) {
              updated[index] = {
                ...updated[index],
                name: event.target.value,
              };
            }
            return updated;
          })
        }
        readOnly={!selectedFileId}
      />
      <RoundedInput
        label="Description"
        value={current.description}
        onChange={(event) =>
          setDescriptions((prev) => {
            const updated = [...prev];
            const index = updated.findIndex(
              (desc) =>
                desc.id === selectedFileId || desc.size === selectedFileId
            );
            if (index !== -1) {
              updated[index] = {
                ...updated[index],
                description: event.target.value,
              };
            }
            return updated;
          })
        }
        readOnly={!selectedFileId}
      />
    </div>
  );
}
